import { ConfigurationSchema } from '../configuration'

const configSchema = ConfigurationSchema('BaseFeatureWidget', {})
export { configSchema }
